export default __webpack_public_path__ + "static/media/alert-triangle.fe7de9fb.svg";